import * as React from 'react';

import { LandingPageV2Props } from 'cms';
import { CacheSafeGetServerSideProps } from 'declarations/shared/serverSideProps';
import { WithRouterProps } from 'next/dist/client/with-router';
import { withRouter } from 'next/router';

import AccountFormPage from '../components/account/AccountFormPage';
import ReduxWrapper from '../components/shared/ReduxWrapper';
import LandingPageV2Layout, { getLandingpageV2ServerSideProps } from './shared/LandingPageV2Layout';

export const getServerSideProps: CacheSafeGetServerSideProps<LandingPageV2Props> = async (
  context,
) => {
  //Setting the Slug to fetch the landing Page from Contentful.
  context.params = {
    slug: 'login',
  };

  context.query.slug = 'login';
  return getLandingpageV2ServerSideProps(context);
};

export default withRouter(
  (context: React.PropsWithChildren<WithRouterProps> & LandingPageV2Props) => {
    return (
      <ReduxWrapper>
        <LandingPageV2Layout {...context} hideGoogleOneTap>
          <AccountFormPage {...context.router.query} />
        </LandingPageV2Layout>
      </ReduxWrapper>
    );
  },
);
